







































import { Component, Vue } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import CharacterList from '@/components/parts/CharacterList.vue';
import * as api from './../../api/api';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';

class RankingData {
  public characters: api.Character[];
  public isRankingObject: boolean;

  public constructor(public name: string,
                     public property: string,
                     public rankingProperty: string,
                     charas: api.Character[],
                     isContainsAi: boolean = false) {
    this.isRankingObject = !(!rankingProperty);
    const ranking = Enumerable.from(charas)
      .where((c) => (!this.isRankingObject ? (c as any)[property] : c.ranking[rankingProperty]) > 0 &&
        (isContainsAi || (c.aiType === api.Character.aiHuman || c.aiType === api.Character.aiAdministrator)))
      .orderByDescending((c) => (!this.isRankingObject ? (c as any)[property] : c.ranking[rankingProperty]))
      .take(5);
    this.characters = ranking.toArray();
    console.dir(charas[0]);
  }
}

@Component({
  components: {
    CharacterList,
    CharacterIcon,
  },
})
export default class RankingPage extends Vue {
  public allCharacters: api.Character[] = [];
  public countries: api.Country[] = [];
  public rankings: RankingData[] = [];
  private isLoading: boolean = true;
  private isApp: boolean = false;

  private created() {
    if (this.$route.query.app) {
      this.isApp = true;
    }
    this.initializeAsync()
      .catch(() => {
        NotificationService.getAllCharactersFailed.notify();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private async initializeAsync() {
    const charas = await api.Api.getAllCharacters();
    const allCountries = await api.Api.getAllCountries();
    this.allCharacters = charas;
    this.countries = allCountries.filter((c) => !c.hasOverthrown);

    charas.forEach((c) => {
      const cdata = c as any;
      const crank = cdata.ranking;
      cdata.attributeSum = c.strong + c.intellect + c.leadership + c.popularity;
      cdata.winRate = (crank.battleWonCount + crank.battleLostCount >= 10) ?
        Math.round((crank.battleWonCount / (crank.battleWonCount + crank.battleLostCount)) * 1000) / 10 :
        0;
      cdata.battleKillRate = (crank.battleKilledCount + crank.battleBeingKilledCount > 0) ?
        Math.round((crank.battleKilledCount / (crank.battleKilledCount + crank.battleBeingKilledCount)) * 1000) / 10 :
        0;
    });

    this.rankings.push(new RankingData('総合力', 'attributeSum', '', charas));
    this.rankings.push(new RankingData('武力', 'strong', '', charas));
    this.rankings.push(new RankingData('知力', 'intellect', '', charas));
    this.rankings.push(new RankingData('統率', 'leadership', '', charas));
    this.rankings.push(new RankingData('人望', 'popularity', '', charas));
    this.rankings.push(new RankingData('階級', 'classValue', '', charas));
    this.rankings.push(new RankingData('対人戦闘勝利数', '', 'battleWonCount', charas, true));
    this.rankings.push(new RankingData('対人戦闘敗北数', '', 'battleLostCount', charas, true));
    this.rankings.push(new RankingData('勝率', 'winRate', '', charas, true));
    this.rankings.push(new RankingData('城壁破壊量', '', 'battleBrokeWallSize', charas, true));
    this.rankings.push(new RankingData('支配数', '', 'battleDominateCount', charas, true));
    this.rankings.push(new RankingData('連戦数', '', 'battleContinuousCount', charas, true));
    this.rankings.push(new RankingData('計略使用回数', '', 'battleSchemeCount', charas, true));
    this.rankings.push(new RankingData('倒した兵士数', '', 'battleKilledCount', charas, true));
    this.rankings.push(new RankingData('失った兵士数', '', 'battleBeingKilledCount', charas, true));
    this.rankings.push(new RankingData('戦闘効率', 'battleKillRate', '', charas, true));
    this.rankings.push(new RankingData('布教量', '', 'missionaryCount', charas, true));
    this.rankings.push(new RankingData('信仰・改宗させた回数', '', 'missionaryChangeReligionCount', charas, true));
  }

  private getCountryColorId(countryId: number): number {
    const country = ArrayUtil.find(this.countries, countryId);
    if (country) {
      return country.colorId;
    } else {
      return 0;
    }
  }

  private getCountryName(countryId: number): string {
    const country = ArrayUtil.find(this.countries, countryId);
    if (country) {
      return country.name;
    } else {
      return '無所属';
    }
  }

  private reloadPage() {
    window.location.reload();
  }
}
